import Result, { EmptyResult } from '../Result';
import { Record, Storage } from './types';

export default class LocalStorage implements Storage {
  public getName(): string {
    return 'LocalStorage';
  }

  public async get(key: string): Promise<Result<string | null>> {
    const value = localStorage.getItem(key);

    return new Result(value);
  }

  public async put({ key, value, permanent }: Record): Promise<Result> {
    if (permanent) {
      localStorage.setItem(key, value);
    }

    return new EmptyResult();
  }

  public async remove({ key }: { key: string }): Promise<EmptyResult> {
    localStorage.removeItem(key);

    return new EmptyResult();
  }
}
